import { useBooleanFlagValue } from '@rs-core/hooks/useFlags';
import React, { useState, useCallback, createContext, useContext } from 'react';

const NewWorklistToggleContext = createContext({});

export const NewWorklistToggleProvider = ({ children }) => {
	// Worklist related new ff
	const mavenWorklistGrouping = useBooleanFlagValue('maven-worklist-grouping');
	const mavenStudyPlayerAssignGUI = useBooleanFlagValue('maven-study-player-assign-gui');
	const mavenNewSAYTComponent = useBooleanFlagValue('maven-new-sayt-component');
	const gridCustomHeader = useBooleanFlagValue('meta-grid-custom-header');
	const isToggleFFOn = useBooleanFlagValue('maven-2686-new-worklist-toggle');
	const mavenEnableWorklistContextMenu = useBooleanFlagValue('maven-2735-worklist-right-click-menu');

	const featureFlagsMapping = {
		'maven-worklist-grouping': mavenWorklistGrouping,
		'maven-study-player-assign-gui': mavenStudyPlayerAssignGUI,
		'maven-new-sayt-component': mavenNewSAYTComponent,
		'meta-grid-custom-header': gridCustomHeader,
		'maven-2686-new-worklist-toggle': isToggleFFOn,
		'maven-2735-worklist-right-click-menu': mavenEnableWorklistContextMenu,
	};

	const [isWorklistToggleOn, setIsWorklistToggleOn] = useState(
		localStorage.getItem('worklistToggleState') === 'true' || false
	);

	const enableNewWorklistToggle = () => {
		setIsWorklistToggleOn(!isWorklistToggleOn);
		localStorage.setItem('worklistToggleState', !isWorklistToggleOn);
	};

	const getFeatureFlagValue = useCallback(
		flagName => {
			if (isToggleFFOn) {
				if (Object.hasOwn(featureFlagsMapping, flagName)) {
					return isWorklistToggleOn ? featureFlagsMapping[flagName] : false;
				}
				return false;
			}

			return Object.hasOwn(featureFlagsMapping, flagName) ? featureFlagsMapping[flagName] : false;
		},
		[isWorklistToggleOn, isToggleFFOn]
	);

	return (
		<NewWorklistToggleContext.Provider
			value={{
				enableNewWorklistToggle,
				isWorklistToggleOn,
				toggleGetFeatureFlagValue: getFeatureFlagValue,
				isToggleEnabled: isToggleFFOn,
			}}
		>
			{children}
		</NewWorklistToggleContext.Provider>
	);
};

export const useNewWorklistToggleContext = () => useContext(NewWorklistToggleContext);

export default NewWorklistToggleProvider;
